// Определяем, где ЗАГРУЖАЕТСЯ виджет (а не где открыт сайт пользователя)
const scriptSrc = (document.currentScript as HTMLScriptElement)?.src || '';

//Раскомментируйте нужную строку для вашего окружения

// Для локальной разработки:
// const isWidgetLoadedLocally = true;

// Для продакшена:
const isWidgetLoadedLocally = false;

const emulatorHost = import.meta.env.VITE_FUNCTIONS_EMULATOR_HOST || '127.0.0.1';
const emulatorPort = import.meta.env.VITE_FUNCTIONS_EMULATOR_PORT || '5003';

console.log('[Config] v2.26 Environment Detection:');
console.log('[Config] - Build mode:', import.meta.env.MODE);
console.log('[Config] - Script src:', scriptSrc);
console.log('[Config] - Final isWidgetLoadedLocally:', isWidgetLoadedLocally);
console.log('[Config] - Emulator host:', emulatorHost, 'port:', emulatorPort);

// ПРИОРИТЕТ: env переменные, затем логика на основе места загрузки виджета
const transcribeUrl = import.meta.env.VITE_TRANSCRIBE_URL || 
  (isWidgetLoadedLocally
    ? `http://${emulatorHost}:${emulatorPort}/ai-form-copilot/us-central1/transcribe`
    : 'https://transcribe-72im4s7i4a-uc.a.run.app');

const completeUrl = import.meta.env.VITE_COMPLETE_URL || 
  (isWidgetLoadedLocally
    ? `http://${emulatorHost}:${emulatorPort}/ai-form-copilot/us-central1/complete`
    : 'https://complete-72im4s7i4a-uc.a.run.app');

const detectLanguageUrl = import.meta.env.VITE_DETECT_LANGUAGE_URL || 
  (isWidgetLoadedLocally
    ? `http://${emulatorHost}:${emulatorPort}/ai-form-copilot/us-central1/detectLanguage`
    : 'https://us-central1-ai-form-copilot.cloudfunctions.net/detectLanguage');

const detectSensitiveUrl = import.meta.env.VITE_DETECT_SENSITIVE_URL || 
  (isWidgetLoadedLocally
    ? `http://${emulatorHost}:${emulatorPort}/ai-form-copilot/us-central1/detectSensitive`
    : 'https://us-central1-ai-form-copilot.cloudfunctions.net/detectSensitive');

const generateBadgesUrl = import.meta.env.VITE_GENERATE_BADGES_URL || 
  (isWidgetLoadedLocally
    ? `http://${emulatorHost}:${emulatorPort}/ai-form-copilot/us-central1/generateBadges`
    : 'https://us-central1-ai-form-copilot.cloudfunctions.net/generateBadges');

const translateTextUrl = import.meta.env.VITE_TRANSLATE_TEXT_URL ||
  (isWidgetLoadedLocally
    ? `http://${emulatorHost}:${emulatorPort}/ai-form-copilot/us-central1/translateText`
    : 'https://us-central1-ai-form-copilot.cloudfunctions.net/translateText');

console.log('[Config] Using URLs:');
console.log('[Config] Transcribe:', transcribeUrl);
console.log('[Config] Complete:', completeUrl);
console.log('[Config] DetectLanguage:', detectLanguageUrl);
console.log('[Config] DetectSensitive:', detectSensitiveUrl);
console.log('[Config] GenerateBadges:', generateBadgesUrl);
console.log('[Config] TranslateText:', translateTextUrl);

export const CONFIG = {
    DEFAULT_LANG: 'en',
    SUPPORTED_LANGS: ['en', 'de', 'fr', 'es', 'ru', 'pl', 'it', 'pt', 'zh', 'ja', 'ko', 'ar', 'hi', 'nl', 'sv', 'da', 'no', 'fi', 'tr', 'cs', 'el', 'he', 'th', 'id', 'ro'],
    TRANSCRIBE_FUNCTION_URL: transcribeUrl,
    COMPLETE_FUNCTION_URL: completeUrl,
    DETECT_LANGUAGE_URL: detectLanguageUrl,
    DETECT_SENSITIVE_URL: detectSensitiveUrl,
    GENERATE_BADGES_URL: generateBadgesUrl,
    TRANSLATE_TEXT_URL: translateTextUrl,

    AUDIO: {
        CHROME_SETTINGS: {
            echoCancellation: false,
            noiseSuppression: false,
            autoGainControl: false,
            sampleRate: 48000,
            sampleSize: 24,
            channelCount: 1,
            audioBitsPerSecond: 320000,
            timeslice: 1000
        },
        SAFARI_SETTINGS: {
            echoCancellation: false,
            noiseSuppression: false,
            autoGainControl: false,
            sampleRate: 48000,
            sampleSize: 24,
            channelCount: 1,
            deviceId: 'default',
            timeslice: 500
        },
        IOS_WORKLET_SETTINGS: {
            sampleRate: 48000,
            processorBufferSize: 4096,
            normalizeAudio: true,
            targetFormat: 'wav'
        },
        MIN_BLOB_SIZE: 10000,
        MAX_RECORDING_TIME: 60000,
        CHECK_CONFIDENCE: true,
        MIN_CONFIDENCE: 0.2
    },
    
    FIELD_CONFIDENCE: {
        // Порог уверенности для полей, требующих проверки (желтый аккордеон)
        NEEDS_CHECK_THRESHOLD: 0.7,
        // Минимальный порог для отображения поля как заполненного
        MIN_FILLED_THRESHOLD: 0.3
    }
};